import React from 'react';
import PropTypes from 'prop-types';

const WinsRuns = ({ profileType, wins, runs, percent }) => (
    <div>
        <span className="mp-form__stats">
            <span className="mp-form__stats__label">Wins: </span>
            <strong>
                {wins}
            </strong>
        </span>
        <span className="mp-form__stats">
            <span className="mp-form__stats__label">
                {profileType === 'jockey' ? 'Rides: ' : 'Runs: '}
            </span>
            <strong>
                {runs}
            </strong>
        </span>
        <span className="mp-form__stats">
            <strong>
                ({percent}%)
            </strong>
        </span>
    </div>
);

WinsRuns.propTypes = {
    profileType: PropTypes.string.isRequired,
    wins: PropTypes.number,
    runs: PropTypes.number,
    percent: PropTypes.number,
};

export default WinsRuns;



// WEBPACK FOOTER //
// ./src/js/human/form/components/WinsRuns.jsx